import {createRef, memo, useEffect} from "react";

// Deliberately no sink id — output routing belongs on the tiles that carry audio (RISKS.md/P2.39).
export default memo((props: { stream: MediaStream, className?: string }) => {
  const videoRef = createRef<HTMLVideoElement>()

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = props.stream
    }
  }, [videoRef, props.stream]);

  const classNames = [
    'video-stream',
  ]
  if (typeof props.className !== 'undefined') {
    classNames.push(props.className)
  }

  return (
    <video ref={videoRef} autoPlay style={{width: '100%'}} className={classNames.join(' ')}></video>
  )
})